<div class="overflow-y-auto">
	<h2 class="pt-5">Fire insurance</h2>
	<router-outlet></router-outlet>
</div>
<app-ai-document-processing-loading [matterDocumentType]="fileType">
	<div class="overflow-y-auto flex justify-center items-center h-full">
		<div class="h-full flex flex-1 justify-center pt-5 pl-7 pr-5 pb-5">
			<app-container
				type="dark"
				class="h-full"
				[testHook]="testHooks.Container"
			>
				<app-matter-url-pdf-viewer
					*ngIf="latestDoc?.url"
					[googleSrcUrl]="latestDoc?.url"
					[fileName]="latestDoc?.name"
					[fileType]="latestDoc?.fileType"
					class="h-full"
					[showDelete]="true"
					(delete)="delete()"
				></app-matter-url-pdf-viewer>

				<app-ai-scraping-notification [isUsingIntroduceNotification]="true" />
				<app-sale-file-upload
					*ngIf="!latestDoc?.url"
					type="dropzone"
					class="justify-self-center self-center h-full"
					label="Upload Insurance binder"
					[saleId]="matterId"
					[documentName]="fileName"
					[documentType]="fileType"
					[runAiScraping]="false"
				></app-sale-file-upload>
			</app-container>
		</div>
	</div>
</app-ai-document-processing-loading>
